import { render, staticRenderFns } from "./TrademarkRenewalReport.vue?vue&type=template&id=682e76a0&"
import script from "./TrademarkRenewalReport.vue?vue&type=script&lang=js&"
export * from "./TrademarkRenewalReport.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkRenewalReport.vue?vue&type=style&index=0&id=682e76a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports